export default __webpack_public_path__ + "static/media/Bike_Insurance.3e6c8d59.svg";